var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._m(0),_c('div',{staticClass:"title-right"},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.moreGoods}},[_vm._v("更多礼品"),_c('i',{staticClass:"el-icon-arrow-right"})])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-left"},[_c('span',{staticClass:"rxbd"},[_vm._v("热销榜单")])])
}]

export { render, staticRenderFns }